import TagList, { TagListProps } from './TagList';

export type { TagListProps };
export default TagList;
